import { Box, HStack, Link, Text } from '@wegroup/design-system';
import cogoToast from 'cogo-toast';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useDebouncedCallback } from 'use-debounce/lib';
import { getEnterprisesByName } from '../../../../../../common/src/legacy/services/apiRouterService';
import {
  Enterprise,
  ReturnOptionProps,
} from '../../../../../../../types/ProductFactory';
import SearchSelectInputV2 from '../../../../../../common/src/components/SearchSelectInputV2';

interface CompanyOption {
  value: Enterprise;
  label: string;
}

interface Props {
  handleOnChange: (arg0: boolean | Enterprise) => void;
  onCantFind: () => void;
  countryCode: string;
}

const CompanyRegistrationSearchInput: React.FC<
  React.PropsWithChildren<Props>
> = ({ handleOnChange, onCantFind, countryCode, ...otherProps }) => {
  const { t } = useTranslation();

  const fetchCompanies = async (
    keyword: string,
    cb: (arg0: CompanyOption[]) => void,
  ) => {
    if (keyword.length > 1) {
      const [resp, status] = await getEnterprisesByName(keyword, countryCode);

      if (status !== 200 && resp.msg === 'ENTERPRISE_NOT_FOUND') {
        return cb([]);
      } else if (status !== 200) {
        return cogoToast.error(t('Something went wrong'));
      }

      cb(
        (resp.items as Enterprise[]).map((company) => ({
          value: company,
          label: `${company.cbe} - ${company.name}` || '',
        })),
      );
    }
    return cb([]);
  };

  const [debounceFetchCompanies] = useDebouncedCallback(fetchCompanies, 500);

  const handleSelected = (p: ReturnOptionProps) => {
    handleOnChange(p.value as Enterprise);
  };

  return (
    <Box w="100%" {...otherProps}>
      <StyledSearchSelectInputV2
        async
        isClearable
        name="company_search"
        onSelected={handleSelected}
        loadOptions={debounceFetchCompanies}
        placeholder={t('FLOWS_INPUT_COMPANY_REGISTRATION_SEARCH_PLACEHOLDER')}
      />

      <HStack justifyContent="space-between" mt={4} color="text.gray">
        <Text>{t('FLOWS_INPUT_COMPANY_REGISTRATION_CHARACTERS_HINT')}</Text>
        <Link variant="gray" onClick={onCantFind}>
          {t('FLOWS_INPUT_CANT_FIND_COMPANY')}
        </Link>
      </HStack>
    </Box>
  );
};

const StyledSearchSelectInputV2 = styled(SearchSelectInputV2)`
  background: white;
`;

export default CompanyRegistrationSearchInput;
